import { useState, useId, type ReactNode } from 'react';

/** Keeps children mounted: folding never discards an editor or a pending selection. */
export default function CollapsibleSection({ storageKey, title, children, defaultOpen = true, className = '' }: {
  storageKey: string; title: ReactNode; children: ReactNode; defaultOpen?: boolean; className?: string;
}) {
  const id = useId();
  const [choice, setChoice] = useState<boolean | null>(() => {
    try { const value = localStorage.getItem(storageKey); return value === null ? null : value === 'true'; } catch { return null; }
  });
  const open = choice ?? defaultOpen;
  return <section className={`cui-collapse ${className}`}>
    <button className="cui-collapse-toggle" aria-expanded={open} aria-controls={id} onClick={() => {
      setChoice(!open); try { localStorage.setItem(storageKey, String(!open)); } catch { /* local state works */ }
    }}><span aria-hidden="true">{open ? '▾' : '▸'}</span> {title}</button>
    <div id={id} hidden={!open}>{children}</div>
  </section>;
}
